/**
 * useProposalsFeatureAccess — the access SEAM for the Proposals feature (EPIC-PROP-001).
 *
 * Wraps the pure `isProposalsEnabledForTenant` rule with the active tenant so components can gate
 * the Documents → Proposals sub-section and every entry point with one hook. Mirrors the shape of
 * `useContractsFeatureAccess` so the swap to a real tenant_settings/role gate at GA is mechanical.
 */
import { useTenant } from '@/contexts/TenantContext';
import { isProposalsEnabledForTenant } from '@/lib/proposalsAccess';

export interface ProposalsFeatureAccess {
  /** True when Proposals is enabled for the active tenant (v1: the Sandbox allowlist). */
  enabled: boolean;
}

export function useProposalsFeatureAccess(): ProposalsFeatureAccess {
  const { currentTenant } = useTenant();
  return { enabled: isProposalsEnabledForTenant(currentTenant?.tenant_id) };
}
